'use client';

import { useContext, useMemo } from 'react';
import PropertyListingContext, {
  PropertyContextProps,
} from '@src/contexts/propertyList';

function usePropertyListing(): PropertyContextProps {
  const context = useContext(PropertyListingContext);

  if (context === undefined) {
    throw new Error('usePropertyListing must be used within an app');
  }

  return useMemo(
    () => ({
      ...context,
    }),
    [context]
  );
}

export default usePropertyListing;
